import { useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "../lib/api";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";

export default function PasswordForm({ onDone, currentLabel = "Current password" }) {
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (f.next.length < 8) return setErr("New password must be at least 8 characters.");
    if (f.next !== f.confirm) return setErr("Passwords do not match.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password updated");
      setF({ current: "", next: "", confirm: "" });
      onDone && (await onDone());
    } catch (ex) {
      setErr(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  const field = (k, label, tid) => (
    <div className="space-y-2">
      <Label>{label}</Label>
      <Input type="password" value={f[k]} onChange={set(k)} className="h-12 text-base" data-testid={tid} required />
    </div>
  );

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="change-password-form">
      {field("current", currentLabel, "current-password-input")}
      {field("next", "New password (min 8 characters)", "new-password-input")}
      {field("confirm", "Confirm new password", "confirm-password-input")}
      {err && <div className="rounded-xl bg-red-50 border border-red-200 text-red-700 px-4 py-3 text-sm" data-testid="change-password-error">{err}</div>}
      <Button type="submit" disabled={busy} className="w-full h-12 rounded-xl bg-[#011E38] hover:bg-[#032C52]" data-testid="change-password-submit">
        Update password
      </Button>
    </form>
  );
}
